module.exports = __webpack_public_path__ + "static/media/pc_about_info.3c760242.jpg";